import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbThemeService,
} from "@nebular/theme";
import { UserService } from "../../@core/services/user.service";

import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { QuizContentService } from "../../services/quiz-content.service";
import { Router } from "@angular/router";
import { map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { filter } from "rxjs/operators";
import Quiz from "../../models/quiz.model";
import { DialogQuizContentComponent } from "../dialog-quiz-content/dialog-quiz-content.component";
import { DialogTestQuizComponent } from "../dialog-test-quiz/dialog-test-quiz.component";

@Component({
  selector: "ngx-view-quiz-card",
  styleUrls: ["./view-quiz-card.component.scss"],
  templateUrl: "./view-quiz-card.component.html",
})
export class ViewQuizCardComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() quiz: Quiz;
  @Input() mode?: string = "home"; //home / tutor / detail
  @Input() isMore? = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  loading = false;
  submitted = false;
  view = "question";
  uid = "";
  menuItems: NbMenuItem[] = [
    { title: "Chi tiết", icon: "external-link-outline" },
  ];
  isMobile = false;

  constructor(
    public userService: UserService,
    private quizService: QuizContentService,
    private dialogService: NbDialogService,
    private router: Router,
    private nbMenuService: NbMenuService,
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "anonymous";
        }
      });

    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$)
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });
  }

  ngOnInit() {
    this.nbMenuService
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === `action-buttons-${this.quiz.id}`),
        map(({ item }) => item),
        takeUntil(this.destroy$)
      )
      .subscribe((item) => {
        switch (item.title) {
          case "Sửa":
            this.edit(item.data);
            break;
          case "Xóa":
            this.delete(item.data.id);
            break;
          case "Chi tiết":
            break;
          default:
            break;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  testQuiz(item: Quiz) {
    this.dialogService.open(DialogTestQuizComponent, {
      context: {
        quizId: item.id,
      },
      closeOnBackdropClick: false,
    });
  }

  openTestQuiz(item: Quiz) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/quiz/${item.id}`])
    );
    window.open(url, "_blank");
  }

  loadContent(value) {
    // if (value && (this.isMobile || this.lecture.sourceType == "document")) {
    //   this.router.navigateByUrl(`/lecture/${this.lecture.id}`);
    // }
    this.isMore = value;
  }

  loadButtonAction(item) {
    if (item.createdBy === this.uid) {
      this.menuItems = [
        { title: "Sửa", icon: "edit-2-outline", data: item },
        { title: "Xóa", icon: "trash-2-outline", data: { id: item.id } },
        {
          title: "Chi tiết",
          icon: "external-link-outline",
          link: `/quiz/${this.quiz.id}`,
        },
      ];
    } else {
      this.menuItems = [
        {
          title: "Chi tiết",
          icon: "external-link-outline",
          link: `/quiz/${this.quiz.id}`,
        },
      ];
    }
  }

  tagSelected(tag) {
    console.log("tagSelected:", tag);
  }

  delete(id) {
    if (!this.submitted) {
      this.submitted = true;
      this.dialogService
        .open(DialogYesNoPromptComponent, {
          context: {
            title: "Bạn có chắc xóa nội dung này?",
          },
        })
        .onClose.subscribe((value) => {
          if (value) {
            this.loading = true;
            this.quizService
              .delete(id)
              .then((result) => {
                this.loading = false;
                this.submitted = false;
                this.onDelete.emit(id);
              })
              .catch((err) => {
                this.loading = false;
                this.submitted = false;
              });
          }
          this.submitted = false;
        });
    }
  }

  edit(item: Quiz) {
    // let lecBk = new Quiz();
    // lecBk = clone(item);
    this.dialogService
      .open(DialogQuizContentComponent, {
        context: {
          title: "Cập nhật nội dung cho câu hỏi",
          quizId: item.id,
          isEditSource: true,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          item = value;
          this.quiz = value;
          this.onEdit.emit(value);
        }
      });
  }
}
